module.exports = __webpack_public_path__ + "img/img-6.963e7029.jpg";